/**
 * 获取视频文件的真实时长
 * @param videoUrl 视频文件URL
 * @returns Promise<number> 视频时长（秒）
 */
export const getVideoDuration = (videoUrl: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    
    video.onloadedmetadata = () => {
      resolve(video.duration);
    };
    
    video.onerror = () => {
      reject(new Error('Failed to load video'));
    };
    
    video.src = videoUrl;
  });
};

/**
 * 批量获取多个视频的真实时长
 * @param videoUrls 视频URL数组
 * @returns Promise<number[]> 对应的视频时长数组
 */
export const getMultipleVideoDurations = async (videoUrls: string[]): Promise<number[]> => {
  const promises = videoUrls.map(url => getVideoDuration(url));
  return Promise.all(promises);
};